import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import { Card, Tooltip, Typography } from '@/ui';

import { Props } from './types';

const EventPanel: React.FC<Props> = ({
  edge,
  title,
  titleTooltip,
  isNested = false,
  padding,
  children
}) => {
  const heading = title && (
    <Typography variant={isNested ? 'caption' : 'subheading'} weight="semibold">
      {title}
      {titleTooltip && <FontAwesomeIcon icon={faQuestionCircle} className="ml-1 text-gray-400" />}
    </Typography>
  );

  return (
    <Card
      padding={padding ?? (isNested ? 'xs' : 'sm')}
      className={`space-y-2 ${isNested ? 'mt-2' : `border-l-4 ${edge ?? ''}`}`}>
      {titleTooltip ? <Tooltip content={titleTooltip}>{heading}</Tooltip> : heading}
      <div
        className={`grid grid-cols-[max-content_1fr] items-baseline gap-x-2 gap-y-1 [&>:not([data-event-field])]:col-span-full ${
          isNested ? 'text-xs' : 'text-sm'
        }`}>
        {children}
      </div>
    </Card>
  );
};

export default EventPanel;
